var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H5V4H3V10H5V12H11V10H5V4H11V2ZM11 4H13V10H11V4ZM0 16H2V20H14V22H0V16ZM2 16H14V14H2V16ZM16 16H14V22H16V16ZM15 2H19V4H15V2ZM19 10H15V12H19V10ZM19 4H21V10H19V4ZM24 16H22V20H18V22H24V16ZM18 14H22V16H18V14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersM);
export default __webpack_public_path__ + "static/media/users-m.96ebf133068a72e745611d6de34c37b9.svg";
export { ForwardRef as ReactComponent };